export const GET_DROPDOWNS_DATA = "GET_DROPDOWNS_DATA";
export const FILE_COMPLAIN = "FILE_COMPLAIN";
export const SITE_TYPES = "SITE_TYPES";
export const GET_SITE_INFO = "GET_SITE_INFO";
export const GET_COMPLAINS_LIST = "GET_COMPLAINS_LIST";
export const COMPLAIN_RAISED_TICKET = "COMPLAIN_RAISED_TICKET";
export const CLOSED_COMPAIN = "CLOSED_COMPAIN";
export const REOPEN_COMPLAIN = "REOPEN_COMPLAIN";
export const GET_VIEW_COMPAIN = "GET_VIEW_COMPAIN";
export const GET_TS_QUESTIONNAIRE = "GET_TS_QUESTIONNAIRE";
export const POST_TS_QUESTIONNAIRE = "POST_TS_QUESTIONNAIRE";
export const GET_COMPLAINS = "GET_COMPLAINS";
export const GET_COMPLAINS_LIST_L2 = "GET_COMPLAINS_LIST_L2";
export const GET_CATEGORY_CX_CATEGORY = "GET_CATEGORY_CX_CATEGORY";
export const GET_CATEGORY_CX_L1 = "GET_CATEGORY_CX_L1";
export const GET_CATEGORY_CX_L2 = "GET_CATEGORY_CX_L2";
export const GET_CATEGORY_CX_L3 = "GET_CATEGORY_CX_L3";
export const SAVE_ASSIGNEE_TICKET = "SAVE_ASSIGNEE_TICKET";
export const CLOSE_DUPLICATE_COMPLAINT = "CLOSE_DUPLICATE_COMPLAINT";
export const ISSUE_SUBTYPE = "ISSUE_SUBTYPE";
export const FETCH_ALL_ISSUES = "FETCH_ALL_ISSUES";
export const SAVE_ISSUE_REPLY = "SAVE_ISSUE_REPLY";
export const CENTRAL_TECH_COMPLAINS = "CENTRAL_TECH_COMPLAINS";
export const CENTRAL_TECH_COMPLAINS_LIST = "CENTRAL_TECH_COMPLAINS_LIST";
export const CENTRAL_TECH_LIST = "CENTRAL_TECH_LIST";
export const CENTRAL_TECH_CHANGE = "CENTRAL_TECH_CHANGE";
export const SAVE_CTE_COMPLAIN_REMARKS = "SAVE_CTE_COMPLAIN_REMARKS";
export const CTE_ISSUE_LISTING="CTE_ISSUE_LISTING";
